import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import LandingPageProfileCards from '@/app/components/LandingPage/LandingPageProfileCards/LandingPageProfileCards';

import { medicalAdvisors } from '../_data/medicalAdvisors';

const ScienceAndResearchMedicalAdvisors = (): JSX.Element => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;

    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read_more',
      location: 'science and research',
      path: href,
    });
  };

  return (
    <section
      className="flex flex-col gap-4 bg-neutral-800 pt-20 text-sandstone-200"
      data-cy="science-and-research-advisors"
    >
      <LandingPageBlurb
        title={{
          colEnd: {
            lg: 14,
          },
          indentation: 'pl-32 lg:pl-14 xl:pl-32',
          key: 'science_and_research_carousel_title',
          multiline: true,
        }}
        description={{
          alignment: 'top',
          key: 'science_and_research_carousel_description',
        }}
        action={{
          arrow: true,
          className: 'px-0',
          dataCy: 'science-and-research-mab-action',
          href: '/medical-advisory-board',
          title: 'science_and_research_carousel_button',
          onClick: handleClick,
        }}
      />
      <LandingPageProfileCards cards={medicalAdvisors} />
    </section>
  );
};

export default ScienceAndResearchMedicalAdvisors;
